export enum BulkOperationFailure {
    maxBatchSizeReached = 1,
    ticketNotFound = 2,
    ticketIsAssignedToBot = 3,
    notAllowedToChangeTicketAssignee = 4,
    alreadyUpdatedTicket = 5,
    notAllowedToChangeCategoryDueToZissonInteract = 6,
    ticketIsAssignedToAnotherUser = 7,
    notAllowedToChangeStatusDueToMissingRequiredCategory = 8,
    notAllowedToChangeStatusDueToMissingRequiredTags = 9,
    unexpectedError = 10,
    repliesAlreadyDeleted = 11,
    differentTicketThread = 12,
    ticketSourceIsDeprecated = 13,
    notAllowedToChangeStatusDueToMissingRequiredTeamFields = 14,
}
